var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"grey lighten-2"},[_c('router-view',{on:{"page-mounted":_vm.handlePageMounted}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }